import { buildSearchForm } from "@magicware/forms/builder/searchForm";
import { SearchForm } from "@magicware/forms/components/Form";
import FormGrid from "@magicware/forms/components/FormGrid";
import FormTextField from "@magicware/forms/mui/FormTextField";
import { useTranslation } from "react-i18next";
import { parametersScopeThunks } from "../../redux/parametersScopes/parametersScopesReducer";
import { RootState } from "../../redux/types";
import { FormBrandsAutocomplete } from "../brands/FormBrandsAutocomplete";

const { f, useSearchForm } = buildSearchForm(
    parametersScopeThunks.loadList,
    (state: RootState) => state.parametersScopes.list?.filter,
    () => ({}),
);

export default function ParametersScopeSearchForm() {
    const { t } = useTranslation();
    const searchForm = useSearchForm();
    return (
        <SearchForm {...searchForm}>
            <FormGrid tw="md:grid-cols-2">
                <FormTextField f={f} field="name" label={t("name-label")} searchIcon />
                <FormBrandsAutocomplete
                    f={f}
                    field="brandId"
                    label={t("brand-label")}
                    searchIcon
                    multiple
                    filter={{}}
                />
            </FormGrid>
        </SearchForm>
    );
}
